import type { ReactNode } from 'react';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import type { MessageKey } from '@/modules/localizations';
import { Heading } from '@/modules/ui';

import prizepoolHeader from '../../assets/prizepoolHeader.png';
import * as felaRules from './ReviewPrizepoolLayout.rules';

export interface ReviewPrizepoolLayoutProps {
    title: MessageKey;
    content: ReactNode;
    buttons?: ReactNode;
    showImage?: boolean;
}

export const ReviewPrizepoolLayout = ({ title, content, buttons, showImage = false }: ReviewPrizepoolLayoutProps) => {
    const { css } = useFela();

    return (
        <div className={css(felaRules.container)}>
            {showImage && <img className={css(felaRules.image)} src={prizepoolHeader} alt='' />}
            <Heading variant='h2' elementType='h2' color='black'>
                <FormattedMessage id={title} />
            </Heading>
            <div>{content}</div>
            {Boolean(buttons) && <div className={css(felaRules.buttonsContainer)}>{buttons}</div>}
        </div>
    );
};
